/**
 * BOOTECH Mega Menu v5
 * - Desktop: Posicionamiento dinámico + navegación por hover
 * - Mobile: Accordion multinivel con protección contra cierre de Dawn
 */
(function() {
  'use strict';
  
  // ═══════════════════════════════════════════════════════════════════════════
  // VARIABLES GLOBALES
  // ═══════════════════════════════════════════════════════════════════════════
  
  var isInteracting = false;

  // ═══════════════════════════════════════════════════════════════════════════
  // DESKTOP: POSICIONAMIENTO DEL MEGA MENU
  // ═══════════════════════════════════════════════════════════════════════════
  
  function updateMegaMenuPosition() {
    var header = document.querySelector('.section-header .header, .header, header');
    var megaMenus = document.querySelectorAll('.btm-mega');
    
    if (header && megaMenus.length > 0) {
      var headerRect = header.getBoundingClientRect();
      var topPosition = headerRect.bottom;
      
      megaMenus.forEach(function(mega) {
        mega.style.top = topPosition + 'px';
      });
    }
  }
  
  function initDesktopMegaMenu() {
    // Posicionamiento inicial
    updateMegaMenuPosition();
    
    // Actualizar en scroll y resize
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
      scrollTimeout = requestAnimationFrame(updateMegaMenuPosition);
    }, { passive: true });
    
    window.addEventListener('resize', function() {
      if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
      scrollTimeout = requestAnimationFrame(updateMegaMenuPosition);
    }, { passive: true });
    
    // Observer para detectar cambios en el header (sticky, animaciones)
    var header = document.querySelector('.section-header .header, .header, header');
    if (header && window.MutationObserver) {
      var observer = new MutationObserver(updateMegaMenuPosition);
      observer.observe(header, { 
        attributes: true, 
        attributeFilter: ['class', 'style'] 
      });
    }
    
    // Navegación entre categorías (hover)
    document.querySelectorAll('.btm-mega__category').forEach(function(cat) {
      cat.addEventListener('mouseenter', function() {
        var mega = this.closest('.btm-mega');
        var index = this.dataset.categoryIndex;
        
        if (!mega || !index) return;
        
        // Activar categoría
        mega.querySelectorAll('.btm-mega__category').forEach(function(c) {
          c.classList.remove('is-active');
        });
        this.classList.add('is-active');
        
        // Activar panel correspondiente
        mega.querySelectorAll('.btm-mega__panel').forEach(function(p) {
          p.classList.remove('is-active');
        });
        var panel = mega.querySelector('[data-panel-index="' + index + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // MOBILE: ACCORDION
  // ═══════════════════════════════════════════════════════════════════════════
  
  function handleAccordionClick(e) {
    var btn = e.target.closest('[data-btm-accordion]');
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    isInteracting = true;
    
    var panelId = btn.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    var level = btn.dataset.btmAccordion;
    
    // Cerrar otros del mismo nivel (efecto acordeón)
    var selector = '[data-btm-accordion="' + level + '"]';
    document.querySelectorAll(selector).forEach(function(otherBtn) {
      if (otherBtn !== btn) {
        otherBtn.setAttribute('aria-expanded', 'false');
        var otherPanelId = otherBtn.getAttribute('aria-controls');
        var otherPanel = document.getElementById(otherPanelId);
        if (otherPanel) {
          otherPanel.classList.remove('is-open');
          otherPanel.setAttribute('aria-hidden', 'true');
        }
      }
    });
    
    // Toggle actual
    if (isOpen) {
      btn.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
    } else {
      btn.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
      }
    }
    
    // Mantener foco para evitar que Dawn detecte pérdida de foco
    btn.focus();
    
    setTimeout(function() {
      isInteracting = false;
    }, 300);
    
    return false;
  }

  function initMobileAccordion() {
    var nav = document.querySelector('.btm-mobile-nav');
    if (!nav) return;
    
    // Usar delegación de eventos
    nav.removeEventListener('click', handleAccordionClick, true);
    nav.addEventListener('click', handleAccordionClick, true);
    
    // Bloquear eventos en paneles que podrían cerrar el drawer
    document.querySelectorAll('.btm-mobile__panel, .btm-mobile__subpanel').forEach(function(panel) {
      if (panel.dataset.btmEventsInit) return;
      panel.dataset.btmEventsInit = 'true';
      
      ['click', 'focusin', 'focusout', 'mousedown', 'touchstart'].forEach(function(evt) {
        panel.addEventListener(evt, function(e) {
          // Permitir clicks en links para navegación
          if (e.target.tagName === 'A' && e.target.href) return;
          // Permitir clicks en botones de accordion
          if (e.target.closest('[data-btm-accordion]')) return;
          e.stopPropagation();
        }, true);
      });
    });
    
    // Bloquear focusout en botones
    document.querySelectorAll('[data-btm-accordion]').forEach(function(btn) {
      if (btn.dataset.btmFocusInit) return;
      btn.dataset.btmFocusInit = 'true';
      
      ['focusout', 'blur'].forEach(function(evt) {
        btn.addEventListener(evt, function(e) {
          if (isInteracting) {
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        }, true);
      });
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // MOBILE: PARCHE PARA DAWN HEADER-DRAWER
  // ═══════════════════════════════════════════════════════════════════════════
  
  function patchHeaderDrawer() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer || headerDrawer._btmPatched) return;
    
    headerDrawer._btmPatched = true;
    
    // Parchear onFocusOut para evitar cierre al interactuar con accordion
    if (headerDrawer.onFocusOut) {
      var originalOnFocusOut = headerDrawer.onFocusOut.bind(headerDrawer);
      headerDrawer.onFocusOut = function(event) {
        if (isInteracting) return;
        var drawer = this.querySelector('.menu-drawer');
        if (drawer && drawer.contains(event.relatedTarget)) return;
        if (event.relatedTarget && event.relatedTarget.closest('.btm-mobile-nav')) return;
        originalOnFocusOut(event);
      };
    }
    
    // Parchear closeMenuDrawer
    if (headerDrawer.closeMenuDrawer) {
      var originalClose = headerDrawer.closeMenuDrawer.bind(headerDrawer);
      headerDrawer.closeMenuDrawer = function(event, elementToFocus) {
        if (isInteracting) return;
        if (event && event.target && event.target.closest('.btm-mobile-nav')) return;
        originalClose(event, elementToFocus);
      };
    }
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // INICIALIZACIÓN
  // ═══════════════════════════════════════════════════════════════════════════
  
  function init() {
    initDesktopMegaMenu();
    initMobileAccordion();
    patchHeaderDrawer();
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-inicializar cuando se abre el drawer móvil
  var details = document.getElementById('Details-menu-drawer-container');
  if (details) {
    details.addEventListener('toggle', function() {
      if (this.open) {
        setTimeout(function() {
          initMobileAccordion();
          patchHeaderDrawer();
        }, 50);
      }
    });
  }

  // Re-inicializar cuando Shopify carga secciones dinámicamente (Theme Editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });
  
})();
